import Users from '@/modules/backend/Users/Users';
import { AxiosInstance } from 'axios';
import RestService from '@/modules/backend/RestService';
import Counters from '@/modules/backend/Counters/Counters';
import Buildings from '@/modules/backend/Buildings/Buildings';
import Accounts from '@/modules/backend/Accounts/Accounts';
import Companies from '@/modules/backend/Companies/Companies';
import { StorageInterface } from '@/modules/backend/StorageInterface';
import LocalStorage from '@/modules/backend/LocalStorage';
import { Permissions } from '@/modules/backend/Permissions/Permissions';
import Roles from '@/modules/backend/Roles/Roles';
import Reports from '@/modules/backend/Report/Reports';
import Events from '@/modules/backend/Events/Events';
import { Locations } from './Locations/Locations';
import { Models } from './Models/Models';
import { Resources } from '@/modules/backend/Resources/Resources';
import { Rates } from '@/modules/backend/Rates/Rates';
import { CountersData } from '@/modules/backend/CounterData/CounterData';
import { Kladr } from '@/modules/backend/Kladr/Kladr';
import { Providers } from '@/modules/backend/Providers/Providers';
import { Billing } from '@/modules/backend/Billing/Billing';
import Search from '@/modules/backend/Search/Search.';

export default class HomeSmartApi {
  public readonly rest: RestService;

  private readonly storage: StorageInterface;
  private readonly users: Users;
  private readonly counters: Counters;
  private readonly buildings: Buildings;
  private readonly accounts: Accounts;
  private readonly companies: Companies;
  private readonly permissions: Permissions;
  private readonly roles: Roles;
  private readonly reports: Reports;
  private readonly events: Events;
  private readonly locations: Locations;
  private readonly models: Models;
  private readonly resources: Resources;
  private readonly rates: Rates;
  private readonly countersData: CountersData;
  private readonly kladr: Kladr;
  private readonly providers: Providers;
  private readonly billing: Billing;
  private readonly search: Search;

  // tslint:disable-next-line:no-unnecessary-initializer
  public constructor(axios: AxiosInstance, host = '', storage: StorageInterface|undefined = undefined) {
    this.storage = storage !== undefined ? storage : new LocalStorage();
    this.rest = new RestService(axios, host, this.storage);
    this.users = new Users(this.rest);
    this.counters = new Counters(this.rest);
    this.buildings = new Buildings(this.rest);
    this.accounts = new Accounts(this.rest);
    this.companies = new Companies(this.rest);
    this.permissions = new Permissions(this.rest);
    this.roles = new Roles(this.rest);
    this.reports = new Reports(this.rest);
    this.events = new Events(this.rest);
    this.locations = new Locations(this.rest);
    this.models = new Models(this.rest);
    this.resources = new Resources(this.rest);
    this.rates = new Rates(this.rest);
    this.countersData = new CountersData(this.rest);
    this.kladr = new Kladr(this.rest);
    this.providers = new Providers(this.rest);
    this.billing = new Billing(this.rest);
    this.search = new Search(this.rest);
  }

  public get Rates(): Rates {
    return this.rates;
  }

  public get Resources(): Resources {
    return this.resources;
  }

  public get Models(): Models {
    return this.models;
  }

  public get Locations(): Locations {
    return this.locations;
  }

  public get Users(): Users {
    return this.users;
  }

  public get Counters(): Counters {
    return this.counters;
  }

  public get Buildings(): Buildings {
    return this.buildings;
  }

  public get Accounts(): Accounts {
    return this.accounts;
  }

  public get Companies(): Companies {
    return this.companies;
  }

  public get Permissions(): Permissions {
    return this.permissions;
  }

  public get Roles(): Roles {
    return this.roles;
  }

  public get Reports(): Reports {
    return this.reports;
  }

  public get Events(): Events {
    return this.events;
  }

  public get CountersData(): CountersData {
    return this.countersData;
  }

  public get Kladr(): Kladr {
    return this.kladr;
  }

  public get Providers(): Providers {
    return this.providers;
  }

  public get Billing(): Billing {
    return this.billing;
  }

  public get Search(): Search {
    return this.search;
  }
}
